import { lazy, useCallback } from 'react';

import { useFlag } from '../services/launchDarkly';
import { postPurchaseDepositLimitsPreflight } from '../services/purchaseDepositLimitsPreflight';
import { useStores } from '../stores/useStores';

const PurchaseLimitExceeded = lazy(() => import('../features/payments/PurchaseLimitExceeded'));

export function usePurchaseDepositLimitsPreflight() {
  const isEnabled = useFlag('purchase_deposit_limits_preflight_enabled', false);
  const { portalStore, uiStore } = useStores();

  const ensurePurchaseDepositAllowed = useCallback(
    async (packageId: number | undefined | null): Promise<boolean> => {
      if (!isEnabled || packageId == null) {
        return true;
      }

      const data = await postPurchaseDepositLimitsPreflight(packageId);

      if (!data || data.allowed) {
        return true;
      }

      uiStore.setCloseDialog(true);
      portalStore.openPortal(PurchaseLimitExceeded);
      return false;
    },
    [isEnabled, portalStore, uiStore],
  );

  return { ensurePurchaseDepositAllowed };
}
